import { v4 as uuidv4 } from "uuid"
import { addPrintRequest, store } from "@redux"

const selectPrintTemplateType = (data) => {
  if (data.printerSettings.forPos)
    return "thermal"

  if (data.printerSettings.printerModel !== "thermal")
    return "other"

  if (data.printerSettings.printerInterface === "usb")
    return "other"

  return "thermal"
}

const createPrintRequest = (data) => (
  new Promise((resolve, reject) => {
    const templateType =
      selectPrintTemplateType(data)

    store.dispatch(
      addPrintRequest({
        printRequestId: uuidv4(),
        templateType,
        resolve,
        reject,
        ...data
      })
    )
  })
)

export default createPrintRequest